import * as React from 'react';
import { Typography, Divider, IconButton, Collapse } from '@material-ui/core';
import { ExpandMore, ExpandLess } from '@material-ui/icons';
import { SectionField, TemplateSection, ScoreByRankMap, TemplateSectionContainerProps, TemplateScoreContextType } from '../typings';
import SectionFieldContainer from './SectionFieldContainer';
import useTemplateSectionStyle from '../styles/TemplateSectionContainer';
import { TemplateScoreContext } from '../contexts/TemplateScoreContext';
import { getScoreDisplayValues } from '../utils/previewScoreUtils';
import Score from './SectionFields/Score';

function renderTemplateSectionTitle(
  isMobile: boolean,
  templateSection: TemplateSection,
  templateMaxScoreMap: ScoreByRankMap,
  isCollapsed: boolean,
  onToggle: () => void,
  showDivider: boolean = true
) {
  const { name, rank } = templateSection;
  const templateScore = React.useContext<TemplateScoreContextType>(TemplateScoreContext);
  const sectionScoreMap = templateScore.templateScoreMap[rank] ?? {};
  let displayedScoreStr = '';
  if (templateMaxScoreMap) {
    const maxScores = templateMaxScoreMap[rank] ?? 0;
    const sectionScoreEnabled = templateMaxScoreMap[rank] !== undefined;
    displayedScoreStr = sectionScoreEnabled ? getScoreDisplayValues(sectionScoreMap, maxScores) : '';
  }
  const classes = useTemplateSectionStyle();
  const className = isMobile ? classes.templateSectionTitleMobile : classes.templateSectionTitleWeb;
  return (
    <>
      {showDivider ? <Divider aria-hidden='true' style={{ margin: '1rem 0' }} /> : null}
      <div className={classes.titleSectionContainer}>
        <Typography variant='h2' className={className} key={name}>
          {name}
        </Typography>
        <IconButton
          onClick={onToggle}
          size='small'
          aria-label={isCollapsed ? 'Expand section' : 'Collapse section'}
          aria-expanded={!isCollapsed}
        >
          {isCollapsed ? <ExpandMore /> : <ExpandLess />}
        </IconButton>
      </div>
      <Score label='Section Score' scoreValue={displayedScoreStr} isMobile={isMobile} />
    </>
  );
}

const TemplateSectionContainer: React.FC<TemplateSectionContainerProps> = ({
  isMobile,
  templateSection,
  templateLanguage,
  templateMaxScoreMap,
  isCollapsed: initialIsCollapsed = false,
  showDivider = true
}) => {
  const [isCollapsed, setIsCollapsed] = React.useState(initialIsCollapsed);

  const handleToggle = () => {
    setIsCollapsed(!isCollapsed);
  };

  return (
    <div>
      {renderTemplateSectionTitle(isMobile, templateSection, templateMaxScoreMap, isCollapsed, handleToggle, showDivider)}
      <Collapse in={!isCollapsed}>
        <div>
          {templateSection.sectionFields.map((eachSectionField: SectionField) => (
            <div key={`sectionField_${eachSectionField.rank}`}>
              <SectionFieldContainer
                isMobile={isMobile}
                sectionFieldDetails={eachSectionField}
                sectionRank={templateSection.rank}
                templateLanguage={templateLanguage}
              />
            </div>
          ))}
        </div>
      </Collapse>
    </div>
  );
};

export default TemplateSectionContainer;
